import { Subscription, SubscriptionStatus } from '@/shared/types/Billing';

import { isSubscriptionActive } from './isSubscriptionActive';

const FREE_SUBSCRIPTION_ID_PREFIXES = ['free_sub_', 'sub_free_'];

/**
 * Paid subscription with status active (not free, not Stripe trialing/incomplete/past_due) that is
 * still within its period and not paused. Recording is included in every paid subscription.
 */
export const isPaidSubscription = (subscription: null | Subscription | undefined): boolean =>
  Boolean(
    subscription &&
      subscription.status === SubscriptionStatus.Active &&
      !FREE_SUBSCRIPTION_ID_PREFIXES.some((prefix) => subscription.id.startsWith(prefix)) &&
      isSubscriptionActive(subscription),
  );
